import { Box, CircularProgress, Typography } from "@mui/material";
import PropTypes from "prop-types"; // Optional: for prop validation
import { useDesignTokens } from "../../../theme/useDesignTokens";

/**
 * Common Loading State Component
 */
const ScreenLoader = ({
  height = "80vh",
  size = 64,
  color = "",
  message = "",
  sx = {},
}) => {
  const { colors, font } = useDesignTokens();

  if (color === "") {
    color = colors?.primary?.main;
  }

  return (
    <Box
      sx={{
        height,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        // backgroundColor: "#FFFFFF",
        backgroundColor: "background.default",
        ...sx,
      }}
    >
      <CircularProgress
        size={size}
        sx={{ color }}
        role="status"
        aria-busy={true}
        aria-label={message || "Loading..."}
      />

      {message && (
        <Typography
          variant="body1"
          sx={{ mt: 1, fontSize: font?.size?.fontSz18 }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

// Optional: PropTypes for better type checking in JS projects
ScreenLoader.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  message: PropTypes.string,
  sx: PropTypes.object,
};

export default ScreenLoader;
